import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Rocket, AlertCircle, CheckCircle } from 'lucide-react';
import { deploySchool } from '../api';

export default function DeploySchool() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    school_id: '', name: '', dbn: '', plan: 'basic',
    custom_domain: '', monthly_price: '350',
    contact_name: '', contact_email: '', enable_sports: false,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!/^[a-z0-9-]+$/.test(form.school_id)) {
      setError('School ID must be lowercase letters, numbers, and hyphens only');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await deploySchool(form);
      setSuccess(true);
      setTimeout(() => navigate('/schools'), 2000);
    } catch (e) {
      setError(e.response?.data?.error || 'Deployment failed');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div>
        <div className="page-header"><h2>Deploy New School</h2></div>
        <div className="card">
          <div className="card-body" style={{ textAlign: 'center', padding: 60 }}>
            <CheckCircle size={48} style={{ color: 'var(--green)', marginBottom: 16 }} />
            <h3 style={{ marginBottom: 8 }}>Deployment Started!</h3>
            <p className="text-secondary">
              {form.name} is being deployed. Redirecting to schools list...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <h2>Deploy New School</h2>
        <p>Set up a new school hosting instance</p>
      </div>

      <div className="card">
        <div className="card-header">
          <h3><Rocket size={18} /> School Configuration</h3>
        </div>
        <div className="card-body">
          {error && (
            <div className="login-error" style={{ marginBottom: 20 }}>
              <AlertCircle size={16} />
              <span>{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">School ID *</label>
                <input className="form-input" name="school_id" value={form.school_id} onChange={handleChange} placeholder="e.g. evander-childs" required />
                <span className="form-hint">Lowercase, hyphens only. Used for subdomain.</span>
              </div>
              <div className="form-group">
                <label className="form-label">School Name *</label>
                <input className="form-input" name="name" value={form.name} onChange={handleChange} placeholder="e.g. Evander Childs HS" required />
              </div>
              <div className="form-group">
                <label className="form-label">DBN</label>
                <input className="form-input" name="dbn" value={form.dbn} onChange={handleChange} placeholder="e.g. 10X445" />
              </div>
              <div className="form-group">
                <label className="form-label">Plan</label>
                <select className="form-select" name="plan" value={form.plan} onChange={handleChange}>
                  <option value="basic">Basic — $350/mo</option>
                  <option value="standard">Standard — $500/mo</option>
                  <option value="premium">Premium — $750/mo</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Custom Domain</label>
                <input className="form-input" name="custom_domain" value={form.custom_domain} onChange={handleChange} placeholder="e.g. athletics.evanderchilds.org" />
              </div>
              <div className="form-group">
                <label className="form-label">Monthly Price ($)</label>
                <input className="form-input" name="monthly_price" type="number" value={form.monthly_price} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="form-label">Contact Name</label>
                <input className="form-input" name="contact_name" value={form.contact_name} onChange={handleChange} placeholder="Primary contact" />
              </div>
              <div className="form-group">
                <label className="form-label">Contact Email</label>
                <input className="form-input" name="contact_email" type="email" value={form.contact_email} onChange={handleChange} placeholder="contact@school.org" />
              </div>
            </div>

            <div className="form-group" style={{ marginTop: 8 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 14, fontWeight: 500 }}>
                <input type="checkbox" name="enable_sports" checked={form.enable_sports} onChange={handleChange} style={{ width: 18, height: 18, accentColor: 'var(--accent)' }} />
                Enable Sports Module
              </label>
            </div>

            <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                <Rocket size={16} />
                {loading ? 'Deploying...' : 'Deploy School'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={() => navigate('/schools')}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
